import { useState } from 'react'

import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { type GalleryDisplayType } from '@/defs/gallery'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'

import { useGalleryDisplay } from '../GalleryDisplayProvider/GalleryDisplayProvider'
import { useGalleryGroups } from '../GalleryGroupsProvider/GalleryGroupsProvider'

type Props = {
  editedKeys: (keyof GalleryDisplayType['edited'])[]
}

export const useGalleryBounce = ({ editedKeys }: Props) => {
  const isNavigating = useIsNavigating()
  const { loading } = useGalleryGroups()
  const { edited } = useGalleryDisplay()
  const isRehydrated = useReduxSelector(selectors.isRehydrated)
  const [hasBounced, setHasBounced] = useState(isRehydrated)
  const [isBouncing, setIsBouncing] = useState(false)

  if (!hasBounced && isRehydrated && !isNavigating && !loading) {
    setHasBounced(true)
    setIsBouncing(editedKeys.some((k) => edited[k]))
  }

  return isBouncing
}
